/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';

import localeDe from '@angular/common/locales/de';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import {registerLocaleData} from '@angular/common';

registerLocaleData(localeDe);

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
    // tslint:disable-next-line:no-console
    .catch(err => console.error(err));
